import {
    useGetLoyaltyConfigQuery,
    useUpdateLoyaltyConfigMutation,
} from '@/services/innovorder/modules/modules.endpoints';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { UpdateSplioConfigForm } from './SplioConfigUpdateForm';
const useUpdateSplioConfig = () => {
    const { restaurantId } = useParams<{ restaurantId: string }>();
    const [updateSplioConfig, { isLoading: isUpdating, isSuccess: isUpdateSuccess }] = useUpdateLoyaltyConfigMutation();
    const { data: loyaltyConfig } = useGetLoyaltyConfigQuery({
        restaurantId: Number(restaurantId),
    });

    const {
        control,
        handleSubmit,
        formState: { isDirty, isValid },
    } = useForm<UpdateSplioConfigForm>({
        mode: 'all',
    });

    const onSubmit = (data: UpdateSplioConfigForm) => {
        updateSplioConfig({
            restaurantId: Number(restaurantId),
            allowCustomerRewardUsage: data.allowCustomerRewardUsage,
            useCasualTone: data.useCasualTone,
            formLink: data.formLink || null,
            optInLists: {
                LOYALTY: data.subscriptionToLoyaltyNewsletter,
                MARKETING: data.subscriptionToMarketingNewsletter,
            },
            memberIdentifier: data.memberIdentifier,
            provider: 'splio',
            optIns: loyaltyConfig
                ? loyaltyConfig.optIns.map((optIn) => {
                      if (optIn.optInType === 'MARKETING') {
                          return {
                              ...optIn,
                              optInId: data.optIn,
                          };
                      }
                      return optIn;
                  })
                : [],
            programId: data.programId,
            authenticationMethods: data.authenticationMethods,
            registerMethods: data.registerMethods,
            features: data.features,
        });
    };

    return { control, handleSubmit, onSubmit, isUpdating, isDirty, isUpdateSuccess, isValid };
};

export default useUpdateSplioConfig;
